import "date-fns";
import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  input: (props) => ({
    color: props.color,
    fontSize: props.compact ? "0.8rem" : undefined,
  }),
  label: (props) => ({
    color: props.color,
  }),
  icon: (props) => ({
    color: props.color,
    padding: props.compact ? 4 : undefined,
  }),
  picker: (props) => ({
    marginTop: 0,
    marginBottom: 0,
    width: props.compact ? 118 : 140,
    "& .MuiInputBase-root": {
      fontSize: props.compact ? "0.8rem" : "0.9rem",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: props.color
        ? "rgba(255,255,255,0.4)"
        : "rgba(0,0,0,0.25)",
    },
    "& .MuiIconButton-root": {
      padding: props.compact ? 4 : 8,
    },
  }),
}));

export default function MaterialUIPickers(props) {
  const { required, setValue, value, color, compact } = props;
  const classes = useStyles({ color, compact: !!compact });

  const handleDateChange = (date) => {
    setValue(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={classes.picker}
        required={required}
        margin="none"
        id="date-picker-dialog"
        format="dd/MM/yyyy"
        value={value}
        onChange={handleDateChange}
        InputProps={{
          className: classes.input,
          disableUnderline: false,
        }}
        InputLabelProps={{
          className: classes.label,
        }}
        KeyboardButtonProps={{
          className: classes.icon,
          "aria-label": "change date",
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
